import { Text, required } from '@jfs/ui-new'
import { Dropdown } from '../../components/Dropdown'
import { WrapperText } from '../../components/WrapperText'

export const formData = (
  id: any,
  fileNames: any,
  rules: any,
  onAdd: (values: any) => void,
  onUpdate: (values: any) => void,
  message: string,
) => [
  {
    formItems: [
      {
        fieldName: 'fileName',
        ComponentName: Dropdown,
        title: 'FileName',
        validationSchema: required,
        data: fileNames,
      },
      {
        fieldName: 'rules',
        ComponentName: Dropdown,
        title: 'Rules',
        placeHolder: 'Rules',
        validationSchema: required,
        data: rules,
        isMultiSelect: true,
      },
      {
        fieldName: 'titleHeader',
        ComponentName: Text,
        title: 'selection data format as : ruleId - ruleName',
        type: 'h4',
      },
      {
        fieldName: 'message',
        ComponentName: WrapperText,
        title: message,
        color: 'ERROR',
        hide: message === '',
      },
    ],
    onSubmit: async (values: any) => {
      if (id) {
        onUpdate(values)
      } else {
        onAdd(values)
      }
      return 'end'
    },
    actionTitle: 'Submit',
  },
]
